import * as React from "react";
import { AuditForm } from "../auditmodal/components/AuditModal";
import { AuditModalBody } from "../auditmodal/components/AuditModalBody";
import { ErrorBoundary } from "../errors/ErrorBoundary";
import Modal from "../misc/components/modal";

export interface AnnotationDialogProps {
    header: string;
    content: string;
    onClose: () => void;
    onSubmit: (values: AuditForm) => void;
}

export const AnnotationDialog = ({ header, content, onClose, onSubmit }: AnnotationDialogProps) => {
    return (
        <Modal show={true} header={header} closeModalHandler={onClose}>
            <ErrorBoundary>
                <AuditModalBody isSubmitting={false} onClose={onClose} onSubmit={onSubmit}>
                    {content}
                </AuditModalBody>
            </ErrorBoundary>
        </Modal>      
    );
}
